<template>
<svg width="1159px" height="234px" viewBox="0 0 1159 234" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" class="SolutionDiagram">
    <!-- Generator: Sketch 52.6 (67491) - http://www.bohemiancoding.com/sketch -->
    <title>Grafting_Progress</title>
    <desc>Created with Sketch.</desc>
    <g id="Grafting_Progress" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="proggress" transform="translate(12.000000, 19.000000)">
            <g id="Proggress_bar" transform="translate(250.000000, 0.000000)">
                <path d="M26,37 L139.61499,37 L139.61499,196 L26,196 C14.954305,196 6,187.045695 6,176 L6,57 C6,45.954305 14.954305,37 26,37 Z" id="Queued" fill="#D7D7D7" 
                        class="step" :class="{
                            done: this.getSolutionState.isDone(0),
                            current: this.getSolutionState.isCurrent('QUEUED'),
                            error: this.getSolutionState.isError('QUEUED'),
                        }"
                        step_name="Queued">
                </path>
                <rect id="Modelling" fill="#D7D7D7" x="155" y="37" width="134" height="159"
                        class="step" :class="{
                            done: this.getSolutionState.isDone(3),
                            current: this.getSolutionState.isCurrent('PREPARING_ALIGNMENTS'),
                            error: this.getSolutionState.isError('PREPARING_ALIGNMENTS'),
                        }"
                        step_name="Preparation">
                ></rect>
                <rect id="Modelling-Copy" fill="#D7D7D7" x="304" y="37" width="134" height="159"
                        class="step" :class="{
                            done: this.getSolutionState.isDone(5),
                            current: this.getSolutionState.isCurrent('MODELLING'),
                            error: this.getSolutionState.isError('MODELLING'),
                        }"
                        step_name="Modelling">
                ></rect>
                <rect id="Modelling-Copy-2" fill="#D7D7D7" x="453" y="37" width="134" height="159"
                        class="step" :class="{
                            done: this.getSolutionState.isDone(7),
                            current: this.getSolutionState.isCurrent('RELAXING'),
                            error: this.getSolutionState.isError('RELAXING'),
                        }"
                        step_name="Relaxing">
                ></rect>
                <rect id="Modelling-Copy-3" fill="#D7D7D7" x="602" y="37" width="134" height="159"
                        class="step" :class="{
                            done: this.getSolutionState.isDone(9),
                            current: this.getSolutionState.isCurrent('PROCESSING_RESULTS'),
                            error: this.getSolutionState.isError('PROCESSING_RESULTS'),
                        }"
                        step_name="Finalizing">
                ></rect>
                <path d="M752,37 L865.623962,37 C876.669657,37 885.623962,45.954305 885.623962,57 L885.623962,176 C885.623962,187.045695 876.669657,196 865.623962,196 L752,196 L752,37 Z" id="Finished" fill="#D7D7D7"
                        class="step" :class="{
                            final: true,
                            current: this.getSolutionState.isCurrent('FINISHED'),
                            error: this.getSolutionState.isError('FINISHED'),
                        }"
                        step_name="Finished">
                ></path>
                <g id="labels" font-family="ArialUnicodeMS, Arial Unicode MS" font-size="20" font-weight="normal">
                    <text id="Queued" fill="#4A4A4A">
                        <tspan x="33.2167969" y="21">QUEUED</tspan>
                    </text>
                    <text id="Preparation" fill="#4A4A4A">
                        <tspan x="151.820312" y="21">PREPARATION</tspan>
                    </text>
                    <text id="Modelling" fill="#4A4A4A">
                        <tspan x="312.098633" y="21">MODELLING</tspan>
                    </text>
                    <text id="Relaxing" fill="#4A4A4A">
                        <tspan x="469.928711" y="21">RELAXING</tspan>
                    </text>
                    <!-- <text id="ERRO_finalising" fill="#FFFFFF">
                        <tspan x="632.886719" y="183">ERROR</tspan>
                    </text> -->
                    <text id="Finalising" fill="#4A4A4A">
                        <tspan x="613.433594" y="21">FINALISING</tspan>
                    </text>
                    <text id="Finished" fill="#4A4A4A">
                        <tspan x="767.830078" y="21">FINISHED</tspan>
                    </text>
                </g>
            </g>
            <g id="diagram" transform="translate(0.000000, 80.000000)">
                <g id="Background" transform="translate(60.000000, 0.000000)" fill="#A9A9A9">
                    <polygon id="Line-3-Copy-4" fill-rule="nonzero" transform="translate(147.284615, 38.080460) rotate(90.000000) translate(-147.284615, -38.080460) " points="166.163012 25.6172384 168.555156 30.5069157 128.406219 50.5436812 126.014075 45.6540039"></polygon>
                    <polygon id="Line-3-Copy-5" fill-rule="nonzero" transform="translate(146.661538, 39.339080) rotate(90.000000) translate(-146.661538, -39.339080) " points="169.178614 47.5430735 166.784961 52.4319975 124.144463 31.1350874 126.538116 26.2461634"></polygon>
                    <path d="M147.076923,28.4310345 C139.506374,28.4310345 133.369231,22.232494 133.369231,14.5862069 C133.369231,6.93991976 139.506374,0.74137931 147.076923,0.74137931 C154.647472,0.74137931 160.784615,6.93991976 160.784615,14.5862069 C160.784615,22.232494 154.647472,28.4310345 147.076923,28.4310345 Z M147.076923,25.4942529 C153.041598,25.4942529 157.876923,20.6105543 157.876923,14.5862069 C157.876923,8.56185945 153.041598,3.67816092 147.076923,3.67816092 C141.112248,3.67816092 136.276923,8.56185945 136.276923,14.5862069 C136.276923,20.6105543 141.112248,25.4942529 147.076923,25.4942529 Z" id="Oval-Copy-38" fill-rule="nonzero" transform="translate(147.076923, 14.586207) rotate(90.000000) translate(-147.076923, -14.586207) "></path>
                    <path d="M147.076923,76.2586207 C139.506374,76.2586207 133.369231,70.0600802 133.369231,62.4137931 C133.369231,54.767506 139.506374,48.5689655 147.076923,48.5689655 C154.647472,48.5689655 160.784615,54.767506 160.784615,62.4137931 C160.784615,70.0600802 154.647472,76.2586207 147.076923,76.2586207 Z M147.076923,73.3218391 C153.041598,73.3218391 157.876923,68.4381405 157.876923,62.4137931 C157.876923,56.3894457 153.041598,51.5057471 147.076923,51.5057471 C141.112248,51.5057471 136.276923,56.3894457 136.276923,62.4137931 C136.276923,68.4381405 141.112248,73.3218391 147.076923,73.3218391 Z" id="Oval-Copy-40" fill-rule="nonzero" transform="translate(147.076923, 62.413793) rotate(90.000000) translate(-147.076923, -62.413793) "></path>
                    <polygon id="Line-Copy-37" fill-rule="nonzero" points="119 16 119 13 130 13 130 16"></polygon>
                    <polygon id="Line-Copy-37-Copy-2" fill-rule="nonzero" points="41 64 41 61 130 61 130 64"></polygon>
                    <polygon id="Line-Copy-37-Copy" fill-rule="nonzero" points="80 16 80 13 91 13 91 16"></polygon>
                    <polygon id="Line-Copy-37-Copy-5" fill-rule="nonzero" points="41 16 41 13 52 13 52 16"></polygon>
                    <polygon id="Line-Copy-37-Copy-6" fill-rule="nonzero" points="0 16 0 13 11 13 11 16"></polygon>
                    <polygon id="Line-Copy-37-Copy-7" fill-rule="nonzero" points="0 64 0 61 11 61 11 64"></polygon>
                    <polygon id="Combined-Shape-Copy" points="164.212217 47.0057471 157 37.8094179 164.212217 28 183.653846 37.5028736"></polygon>
                </g>
                <rect id="top_insert_back" fill="#179BAC" x="0" y="48" width="56" height="29" rx="14.5"></rect>
                <rect id="top_scaffold_back" fill="#AC2817" x="0" y="0" width="56" height="29" rx="14.5"></rect>
                <path d="M86,73 C79.9248678,73 75,68.0751322 75,62 C75,55.9248678 79.9248678,51 86,51 C92.0751322,51 97,55.9248678 97,62 C97,68.0751322 92.0751322,73 86,73 Z" id="top_insert_boundaries" fill="#179BAC" fill-rule="nonzero"></path>
                <path d="M207,74 C200.372583,74 195,68.627417 195,62 C195,55.372583 200.372583,50 207,50 C213.627417,50 219,55.372583 219,62 C219,68.627417 213.627417,74 207,74 Z" id="top_insert_grafting" fill="#179BAC" fill-rule="nonzero"></path>
                <path d="M86,26 C79.9248678,26 75,21.0751322 75,15 C75,8.92486775 79.9248678,4 86,4 C92.0751322,4 97,8.92486775 97,15 C97,21.0751322 92.0751322,26 86,26 Z" id="top_scaffold_boundaries" fill="#AC2817" fill-rule="nonzero"></path>
                <path d="M126,26 C119.924868,26 115,21.0751322 115,15 C115,8.92486775 119.924868,4 126,4 C132.075132,4 137,8.92486775 137,15 C137,21.0751322 132.075132,26 126,26 Z" id="top_scaffold_flexibility" fill="#AC2817" fill-rule="nonzero"></path>
                <path d="M165,26 C158.924868,26 154,21.0751322 154,15 C154,8.92486775 158.924868,4 165,4 C171.075132,4 176,8.92486775 176,15 C176,21.0751322 171.075132,26 165,26 Z" id="top_scaffold_cross-correlation" fill="#AC2817" fill-rule="nonzero"></path>
                <path d="M207,27 C200.372583,27 195,21.627417 195,15 C195,8.372583 200.372583,3 207,3 C213.627417,3 219,8.372583 219,15 C219,21.627417 213.627417,27 207,27 Z" id="top_scaffold_grafting" fill="#AC2817" fill-rule="nonzero"></path>
            </g>
        </g>
    </g>
</svg>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: [],

  computed: {
    ...mapGetters(["getSolutionState"]),
  },
};
</script>

<style scoped>

.SolutionDiagram {
  width: 95%;
  margin-left:auto;
  margin-right:auto;
  display:block;
  margin-bottom: 5vh;
  margin-top: 5vh;
}

.done {
  background: #79af50aa;
  fill: var(--insert-light);
  color: whitesmoke
}
.current {
  background: var(--insert-light);
  fill: var(--insert-light);
  font-weight: bold;
  color: whitesmoke;
  stroke: var(--insert);
  stroke-width: 9;
}

.error {
  background: #af5350aa;
  fill: #af5350aa;
}

</style>